import type { ITaxonomySyncRun } from "../types/taxonomy.js";

export const getTaxonomyRunMetricCount = (
  run: Pick<ITaxonomySyncRun, "metrics"> | undefined,
  key: string,
): number => {
  const value = run?.metrics[key];
  return Number.isFinite(value) ? Number(value) : 0;
};

export const hasTaxonomyRunCompletedPageScans = (
  run: Pick<ITaxonomySyncRun, "metrics"> | undefined,
): boolean => {
  const pageScanQueuedCount = getTaxonomyRunMetricCount(
    run,
    "pageScanQueuedCount",
  );

  return (
    getTaxonomyRunMetricCount(run, "coordinatorSchedulingCompleted") > 0 &&
    pageScanQueuedCount > 0 &&
    getTaxonomyRunMetricCount(run, "pageScanCompletedCount") >=
      pageScanQueuedCount
  );
};
